<template>
  <EditAccount type="store" />
</template>

<script>
import EditAccount from '@/components/account/EditAccount.vue'

export default {
  components: {
    EditAccount,
  },
}
</script>
